<!-- <template>
    <div
        class="p-4 rounded-lg justify-start items-start gap-3 flex"
        :class="{
            'bg-amber-50': bgColor === 'amber',
            'bg-white dark:bg-slate-800': bgColor === 'white',
        }"
    >
        <div
            class="w-5 h-5 relative"
            :class="{
                'text-amber-500': iconColor === 'amber',
                'text-red-500': iconColor === 'white',
            }"
        >
            <svg
                v-if="icon === 'circle-x'"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    id="vector"
                    d="M12.5 7.5L7.5 12.5M12.5 12.5L7.5 7.5M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
                    stroke="currentColor"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>

            <svg
                v-if="icon === 'warning'"
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    id="vector"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.716 4.35574C10.3959 3.80677 9.60329 3.80677 9.28318 4.35574L3.44848 14.3621C3.12549 14.9161 3.52523 15.6107 4.16489 15.6107H15.8343C16.4739 15.6107 16.8737 14.9161 16.5507 14.3621L10.716 4.35574ZM7.8434 3.51621C8.80657 1.86439 11.1926 1.86439 12.1558 3.51621L17.9905 13.5226C18.9607 15.1866 17.7613 17.2773 15.8343 17.2773H4.16489C2.23787 17.2773 1.03843 15.1866 2.00871 13.5226L7.8434 3.51621ZM9.99958 7.29332C10.4598 7.29332 10.8329 7.66641 10.8329 8.12665V10.6219C10.8329 11.0821 10.4598 11.4552 9.99958 11.4552C9.53935 11.4552 9.16625 11.0821 9.16625 10.6219V8.12665C9.16625 7.66641 9.53935 7.29332 9.99958 7.29332ZM8.95792 13.1107C8.95792 12.5354 9.42428 12.069 9.99958 12.069C10.5749 12.069 11.0413 12.5354 11.0413 13.1107C11.0413 13.686 10.5749 14.1523 9.99958 14.1523C9.42429 14.1523 8.95792 13.686 8.95792 13.1107Z"
                    fill="currentColor"
                />
            </svg>
        </div>
        <div
            class="grow shrink basis-0 flex-col justify-start items-start gap-1 flex"
        >
            <div class="self-stretch text-slate-800 text-sm font-medium">
                {{ title }}
            </div>
            <div class="self-stretch text-slate-500 text-sm font-normal">
                {{ description }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        bgColor: { type: String, default: 'white' },
        icon: { type: String, default: 'circle-x' },
        iconColor: { type: String, default: 'red-500' },
        title: { type: String },
        description: { type: String },
    },
    setup() {
        return {};
    },
};
</script>

 -->
<template>
    <div
        class="p-4 rounded-lg items-start gap-3 flex"
        :class="{
            'bg-amber-50': bgColor === 'amber',
            'bg-white dark:bg-slate-800': bgColor === 'white',
            'bg-green-100': bgColor === 'green',
            'flex-col mx-auto items-center ': orientation === 'vertical',
            'items-start': orientation === 'horizontal',
        }"
    >
        <div
            class="relative rounded-full flex justify-center items-center"
            :class="{
                'text-amber-500': iconColor === 'amber',
                'text-red-500': iconColor === 'white',
                'text-red-500 bg-red-50': iconColor === 'red',
                'text-green-500 bg-green-50': iconColor === 'green',
                'w-5 h-5': iconSize === 'small',
                'w-10 h-10': iconSize === 'medium',
                'w-16 h-16': iconSize === 'large',
            }"
            v-if="showClose"
        >
            <svg
                v-if="icon === 'circle-x'"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    id="vector"
                    d="M12.5 7.5L7.5 12.5M12.5 12.5L7.5 7.5M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10Z"
                    stroke="currentColor"
                    stroke-width="1.66667"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>

            <svg
                v-else-if="icon === 'warning'"
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    id="vector"
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10.716 4.35574C10.3959 3.80677 9.60329 3.80677 9.28318 4.35574L3.44848 14.3621C3.12549 14.9161 3.52523 15.6107 4.16489 15.6107H15.8343C16.4739 15.6107 16.8737 14.9161 16.5507 14.3621L10.716 4.35574ZM7.8434 3.51621C8.80657 1.86439 11.1926 1.86439 12.1558 3.51621L17.9905 13.5226C18.9607 15.1866 17.7613 17.2773 15.8343 17.2773H4.16489C2.23787 17.2773 1.03843 15.1866 2.00871 13.5226L7.8434 3.51621ZM9.99958 7.29332C10.4598 7.29332 10.8329 7.66641 10.8329 8.12665V10.6219C10.8329 11.0821 10.4598 11.4552 9.99958 11.4552C9.53935 11.4552 9.16625 11.0821 9.16625 10.6219V8.12665C9.16625 7.66641 9.53935 7.29332 9.99958 7.29332ZM8.95792 13.1107C8.95792 12.5354 9.42428 12.069 9.99958 12.069C10.5749 12.069 11.0413 12.5354 11.0413 13.1107C11.0413 13.686 10.5749 14.1523 9.99958 14.1523C9.42429 14.1523 8.95792 13.686 8.95792 13.1107Z"
                    fill="currentColor"
                />
            </svg>
            <Icon v-else :icon="icon" svgClass="w-12 h-12" />
        </div>
        <div
            class="grow shrink basis-0 flex-col justify-start items-start gap-1 flex"
        >
            <div class="self-stretch text-slate-800 dark:text-slate-100 text-sm font-medium">
                {{ title }}
            </div>
            <div class="self-stretch text-slate-500 dark:text-slate-400 text-sm font-normal">
                {{ description }}
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/ui/icon/icon.vue';
export default {
    components: {
        Icon,
    },
    props: {
        bgColor: { type: String, default: 'white' },
        icon: { type: String, default: 'circle-x' },
        iconSize: { type: String, default: 'small' },
        iconColor: { type: String, default: 'red-500' },
        title: { type: String },
        description: { type: String },
        orientation: { type: String, default: 'horizontal' },
        showClose: { type: Boolean, default: true },
    },
    setup() {
        return {};
    },
};
</script>
